import Checkbox from '@mui/material/Checkbox';
import {
  Backdrop,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Box,
  Button,
  Typography,
  TextField,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';
import { useThemes } from '../Theme/theme';
import { useSelector } from 'react-redux';
import { listOutstandingInvoiceMaster, listOutstandingPurchaseMaster } from '../../graphql';
import { defaultRowsPerPageOptions } from '../../utils/common';
import NewAgeingModal from '../modals/NewAgeingModal';
import TDSTCSCustomSearch from './CustomComponents/TDSTCSCustomSearch';
import { Clear, Close, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import CustomDate from '../Date/CustomDate';
import MoneyRanger from '../formElements/MoneyRanger';
import MoneyRangerPayRec from '../formElements/MoneyRangerPayRec';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import NewPayableReceivableAgeing from '../modals/NewPayableReceivableAgeing';
import { DateRangeRsuite } from '../_components';

function NewOutStandingReport({ reportType, tableName }) {
   const tableRef = useRef(null);
  const { theme } = useThemes();
  let keys =
    reportType === 'ReceivableOutStanding'
      ? {
          invoicenumber: 'invoicenumber',
          partyname: 'partyname',
          legalname: 'partylegalname',
          invoiceamount: 'invoiceamount',
          invoiceamountfrom: 'invoiceamountfrom',
          invoiceamountto: 'invoiceamountto',
          receivedamount: 'receivedamount',
          receivedamountfrom: 'receivedamountfrom',
          receivedamountto: 'receivedamountto',
          balancedueamount: 'balancedueamount',
          balancedueamountfrom: 'balancedueamountfrom',
          balancedueamountto: 'balancedueamountto',
          overduedays: 'overduedays',
          overduedaysfrom: 'overduedaysfrom',
          overduedaysto: 'overduedaysto',
          duedate: 'duedate',
          duedatefrom: 'duedatefrom',
          creditperiodfrom: 'creditperiodfrom',
          creditperiodto: 'creditperiodto',
          duedateto: 'duedateto',
          invoicedate: 'invoicedate',
          invoicedatefrom: 'invoicedatefrom',
          invoicedateto: 'invoicedateto',
        }
      : {
          invoicenumber: 'invoicenumber',
          partyname: 'partyname',
          legalname: 'partylegalname',
          invoiceamount: 'granttotalamount',
          invoiceamountfrom: 'granttotalamountfrom',
          invoiceamountto: 'granttotalamountto',
          receivedamount: 'receivedamount',
          receivedamountfrom: 'receivedamountfrom',
          receivedamountto: 'receivedamountto',
          balancedueamount: 'balancedueamount',
          balancedueamountfrom: 'balancedueamountfrom',
          balancedueamountto: 'balancedueamountto',
          overduedays: 'overduedays',
          overduedaysfrom: 'overduedaysfrom',
          overduedaysto: 'overduedaysto',
          duedate: 'duedate',
          duedatefrom: 'duedatefrom',
          duedateto: 'duedateto',
          creditperiodfrom: 'creditperiodfrom',
          creditperiodto: 'creditperiodto',
          invoicedate: 'purchaseinvoicedate',
          invoicedatefrom: 'purchaseinvoicedatefrom',
          invoicedateto: 'purchaseinvoicedateto',
        };

  let headCells =
    reportType === 'ReceivableOutStanding'
      ? [ 
          { id: '1', label: 'Invoice No.', align: 'left' },
          { id: '2', label: 'Invoice Date', align: 'left' },
          { id: '3', label: 'Customer Name', align: 'left' },
          { id: '4', label: 'Invoice Amount', align: 'right' },
          { id: '5', label: 'Received Amount', align: 'right' },
          { id: '6', label: 'Outstanding Amount', align: 'right' },

          { id: '7', label: 'Credit  Period', align: 'right' },
          { id: '8', label: 'Due Date', align: 'left' },
          {
            id: '9',
            label: (
              <span style={{ display: 'inline-flex', alignItems: 'center', fontSize: '14px', lineHeight: '1' }}>
                <span style={{ color: '#00c853', fontWeight: 600 }}>Due in</span>
                <span style={{ color: '#000', fontWeight: 500, margin: '0 4px' }}>/</span>
                <span style={{ color: '#ff1744', fontWeight: 600 }}>Over Due</span>
              </span>
            ),
            align: 'right',
          },
        ]
      : [
          { id: '1', label: 'Voucher Number', align: 'left' },
          { id: '2', label: 'Purchase Date', align: 'left' },
          { id: '3', label: 'Supplier Name', align: 'left' },
          { id: '4', label: 'Purchase Amount', align: 'right' },
          { id: '5', label: 'Paid Amount', align: 'right' },
          { id: '6', label: 'Outstanding Amount', align: 'right' },

          { id: '7', label: 'Credit  Period', align: 'right' },
          { id: '8', label: 'Due Date', align: 'left' },
          {
            id: '9',
            label: (
              <span style={{ display: 'inline-flex', alignItems: 'center', fontSize: '14px', lineHeight: '1' }}>
                <span style={{ color: '#00c853', fontWeight: 600 }}>Due in</span>
                <span style={{ color: '#000', fontWeight: 500, margin: '0 4px' }}>/</span>
                <span style={{ color: '#ff1744', fontWeight: 600 }}>Over Due</span>
              </span>
            ),
            align: 'right',
          },
        ];
  const latestReqIdRef = useRef(0);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [recData, setRecData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [ageingModal, setAgeingModal] = useState(false);
  const [ageingData, setAgeingData] = useState([]);
  const [totalOustandAmt, setTotOustandAmt] = useState(0);
  const [searchValues, setSearchValues] = useState({});
  const [searchType, setSearchType] = useState('');
  const [enableSearch, setEnableSearch] = useState(false);
  const [filterColumns, setFilterColumns] = useState({
    InvoiceDateTo: '',
    InvoiceDateFrom: '',
    DueDateFrom: '',
    DueDateTo: '',
    invoiceamountfrom: '',
    invoiceamountto: '',
    receivedamountfrom: '',
    receivedamountto: '',
    balancedueamountfrom: '',
    balancedueamountto: '',
    creditperiodfrom: '',
    creditperiodto: '',
    overduedaysfrom: '',
    overduedaysto: '',
  });
  const DateRangeRef = useRef(null);
  const format = (num) =>
    Number(num).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);

  const { startTimeStamp, endTimeStamp, range, basedOn } = dashboardData?.bsPeriod;
  useEffect(() => {
    getReceivablesData(startTimeStamp, endTimeStamp, '', 0, 25, true, 0, [], true);
    setSearchValues({});
    setFilterColumns({
      InvoiceDateTo: '',
      InvoiceDateFrom: '',
      DueDateFrom: '',
      DueDateTo: '',
    });
  }, [startTimeStamp, endTimeStamp, basedOn, range]);

  // async function handleSearchChange(value) {
  //   if (value !== '') {
  //     setPage(0);
  //     getReceivablesData(startTimeStamp, endTimeStamp, value, 0, 25, false, 1);
  //   }
  // }
  async function handleSearchChange(value, name) {
    setPage(0);

    setSearchValues((prev) => {
      const updatedSearch = { ...prev };

      if (value !== '') {
        updatedSearch[name] = value;
      } else {
        delete updatedSearch[name]; // Remove field if cleared
      }

      const searchArr = Object.entries(updatedSearch).map(([key, val]) => ({
        [key]: val,
      }));

      getReceivablesData(
        startTimeStamp,
        endTimeStamp,
        '',
        0,
        25,
        Object.keys(updatedSearch).length === 0, // isClear
        Object.keys(updatedSearch).length === 0 ? 0 : 1, // isSearch
        searchArr,
        true
      );

      return updatedSearch;
    });
  }
  async function getReceivablesData(startdt, enddt, value, rowfrom, limitno, open, mode, searchArr, reset) {
    const reqId = ++latestReqIdRef.current;
    try {
      setBackdropOpen(open);
      const resData = await API.graphql(
        graphqlOperation(reportType === 'ReceivableOutStanding' ? listOutstandingInvoiceMaster : listOutstandingPurchaseMaster, {
          startdate: startdt,
          enddate: enddt,
          rowfrom: rowfrom,
          limitno: limitno,
          word: value,
          searchmode: mode,
          ordertype: 'DESC',
          columnname: 'enteredtimesstamp',
          searcharray: JSON.stringify(searchArr),
          ageing: range === 'date' ? 0 : 1,
          basedon: basedOn === 'invoiceDate' ? 1 : 0,
        })
      );
      const outstandingData =
        reportType === 'ReceivableOutStanding' ? resData?.data.listOutstandingInvoiceMaster : resData?.data.listOutstandingPurchaseMaster;

      if (!isNaN(outstandingData[0]?.total_balancedueamount)) {
        setTotOustandAmt(outstandingData[0]?.total_balancedueamount);
      }
      if (outstandingData !== null) {
        let rows = [];
        let overDays = 0;
        let dDate = '';
        let invoiceDate = '';
        let totalOustandAmt = 0;
        await Promise.all(
          outstandingData.map((data) => {
            if (reportType === 'ReceivableOutStanding') {
              // dDate = moment(data?.invoicedate * 1000)
              //   .add(data.creditduration, "days")
              //   .format("DD-MMM-YYYY");
              // overDays = moment(new Date()).diff(
              //   moment(data?.invoicedate * 1000).add(data.creditduration, "days"),
              //   "days"
              // );
              overDays = data?.overduedays;
              dDate = moment(data?.duedate * 1000).format('DD-MMM-YYYY');
              invoiceDate = moment(data?.invoicedate * 1000).format('DD-MMM-YYYY');
            } else {
              //   dDate = moment(data?.purchaseinvoicedate * 1000)
              //   .add(data.creditduration, "days")
              //   .format("DD-MMM-YYYY");
              // overDays = moment(new Date()).diff(
              //   moment(data?.purchaseinvoicedate * 1000).add(data.creditduration, "days"),
              //   "days"
              // );
              overDays = data?.overduedays;
              dDate = moment(data?.duedate * 1000).format('DD-MMM-YYYY');
              invoiceDate = moment(data?.purchaseinvoicedate * 1000).format('DD-MMM-YYYY');
            }

            totalOustandAmt = Number(data?.total_balancedueamount);
            let obj = {
              invNo: reportType === 'ReceivableOutStanding' ? data?.invoicenumber : data?.purchaseinvoicenumber,
              invDate: invoiceDate,
              lName: data?.partylegalname,
              dName: data?.partydisplayname,
              invAmt: reportType === 'ReceivableOutStanding' ? data?.invoiceamount : data?.granttotalamount,
              recAmt: data?.receivedamount,
              creditPrd: data?.creditduration,
              oAmnt: data?.balancedueamount,
              dueDate: dDate,
              overDays: overDays,
              totalCount: data?.recordcount,
              id: reportType === 'ReceivableOutStanding' ? data?.invoiceid : data?.purchaseid,
            };
            rows.push(obj);
          })
        );

        // if (value === '' && mode === 1) {
        //   setRecData((prevData) => [...prevData, ...rows]);
        //   setAgeingData((prevData) => [...prevData, ...outstandingData]);
        // } else {
        //   setRecData(rows);
        //   setAgeingData(outstandingData);
        // }
        if (reset === true) {
          setRecData(rows);
          setAgeingData(outstandingData);
        } else {
          setRecData((prevData) => [...prevData, ...rows]);
          setAgeingData((prevData) => [...prevData, ...outstandingData]);
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      console.log(error);
      setBackdropOpen(false);
    } finally {
      if (reqId === latestReqIdRef.current) {
        setBackdropOpen(false);
      }
    }
  }
  async function handleDateSearchChange(fromDate, toDate, fromKey, toKey) {
    setPage(0);

    setSearchValues((prev) => {
      const updatedSearch = { ...prev };

      if (fromDate || ['overduedaysfrom', 'creditperiodfrom'].includes(fromKey)) {
        updatedSearch[fromKey] = fromDate || 0; // default to 0 if empty
      } else {
        delete updatedSearch[fromKey];
      }

      if (toDate) {
        updatedSearch[toKey] = toDate;
      } else {
        delete updatedSearch[toKey];
      }

      const searchArr = Object.entries(updatedSearch).map(([key, val]) => ({
        [key]: val,
      }));

      getReceivablesData(
        startTimeStamp,
        endTimeStamp,
        '',
        0,
        25,
        Object.keys(updatedSearch).length === 0, // isClear
        Object.keys(updatedSearch).length === 0 ? 0 : 1, // isSearch
        searchArr,
        true
      );

      return updatedSearch;
    });
  }
  const handleFilterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumns };

    if (name === 'invoiceamount') {
      obj['invoiceamountfrom'] = query[0];
      obj['invoiceamountto'] = query[1];
    } else if (name === 'receivedamount') {
      obj['receivedamountfrom'] = query[0];
      obj['receivedamountto'] = query[1];
    } else if (name === 'receivedamount') {
      obj['receivedamountfrom'] = query[0];
      obj['receivedamountto'] = query[1];
    } else if (name === 'balancedueamount') {
      obj['balancedueamountfrom'] = query[0];
      obj['balancedueamountto'] = query[1];
    } else if (name === 'creditperiod') {
      obj['creditperiodfrom'] = query[0];
      obj['creditperiodto'] = query[1];
    } else if (name === 'overduedays') {
      obj['overduedaysfrom'] = query[0];
      obj['overduedaysto'] = query[1];
    }
    setFilterColumns(obj);
  };
  useEffect(() => {
    // if (filterColumns) {
    if (searchType === 'invDate') {
      handleDateSearchChange(filterColumns.InvoiceDateFrom, filterColumns.InvoiceDateTo, keys.invoicedatefrom, keys.invoicedateto);
    } else if (searchType === 'dueDate') {
      handleDateSearchChange(filterColumns.DueDateFrom, filterColumns.DueDateTo, keys.duedatefrom, keys.duedateto);
    } else if (searchType === 'invoiceamount') {
      handleDateSearchChange(filterColumns.invoiceamountfrom, filterColumns.invoiceamountto, keys.invoiceamountfrom, keys.invoiceamountto);
    } else if (searchType === 'receivedamount') {
      handleDateSearchChange(
        filterColumns.receivedamountfrom,
        filterColumns.receivedamountto,
        keys.receivedamountfrom,
        keys.receivedamountto
      );
    } else if (searchType === 'balancedueamount') {
      handleDateSearchChange(
        filterColumns.balancedueamountfrom,
        filterColumns.balancedueamountto,
        keys.balancedueamountfrom,
        keys.balancedueamountto
      );
    } else if (searchType === 'creditperiod') {
      handleDateSearchChange(filterColumns.creditperiodfrom, filterColumns.creditperiodto, keys.creditperiodfrom, keys.creditperiodto);
    } else if (searchType === 'overduedays') {
      handleDateSearchChange(filterColumns.overduedaysfrom, filterColumns.overduedaysto, keys.overduedaysfrom, keys.overduedaysto);
    }
    // }
  }, [filterColumns, searchType]);
useEffect(() => {
    const handleScroll = () => {
      if (tableRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = tableRef.current;
        // Check if the table is scrolled to the very right
        
      }
    };

    const tableElement = tableRef.current;
    if (tableElement) {
      tableElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (tableElement) {
        tableElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return (
    <Box
      sx={{
        marginTop: { xs: '20px', sm: '0px' },
      }}
    >
      <Box
        sx={{
          width: '100%',
          overflow: 'hidden',
        }}
      >
         <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center", // ✅ ensures vertical alignment
    m: 1,
  }}
>
  {/* Left section: Table name + Search button */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.25, // ✅ matches first snippet (≈2px gap)
    }}
  >
    <Typography
      sx={{
        fontWeight: 600,
        fontSize: { xs: "11px", sm: "16px" },
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {tableName}
    </Typography>

    <Tooltip title="Search" placement="top">
      <Button
        sx={{
          borderWidth: "3px",
          borderColor: "primary.main",
          borderStyle: "solid",
          backgroundColor: enableSearch === true && "#f3724a",
          whiteSpace: "nowrap",
          boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
          // m: { sm: "0 6px", md: "0 10px" },
          ml:10,
          fontWeight: "bold",
          "&:active": {
            transform: "scale(0.92)",
            boxShadow: "inset 0px 0px 5px rgba(0, 0, 0, 0.4)",
          },
          height: "30px",
          minWidth: "10px",
          width: "30px",
        }}
        variant="outlined"
        onClick={() => {
          setEnableSearch((prev) => {
            const newState = !prev;
            setSearchValues({});
            if (prev === true) {
              setFilterColumns({
                InvoiceDateTo: "",
                InvoiceDateFrom: "",
                DueDateFrom: "",
                DueDateTo: "",
                invoiceamountfrom: "",
                invoiceamountto: "",
                receivedamountfrom: "",
                receivedamountto: "",
                balancedueamountfrom: "",
                balancedueamountto: "",
                creditperiodfrom: "",
                creditperiodto: "",
                overduedaysfrom: "",
                overduedaysto: "",
              });
             getReceivablesData(startTimeStamp, endTimeStamp, '', 0, 25, true, 0, [], true);
            }
            return newState;
          });
        }}
      >
        <Search sx={{ fontSize: 20 }} />
      </Button>
    </Tooltip>
  </Box>

  {/* Right section: Total Outstanding */}
  <Stack direction="row" spacing={1} alignItems="center">
    <Typography sx={{ fontWeight: 600, fontSize: { xs: "11px", sm: "16px" } }}>
      Total Outstanding : ₹{" "}
      {MoneyFormatv3(Number(totalOustandAmt).toFixed(2), "en-IN")}
    </Typography>
  </Stack>
</Box>

        <TableContainer
           ref={tableRef}
          sx={{
            m: 1,
            '::-webkit-scrollbar': {
              width: 14,
            },
            '::-webkit-scrollbar-track': {},
            '::-webkit-scrollbar-thumb': {
              background: 'primary.main',
            },
            maxHeight: 500,
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              borderRadius: 2,
            }}
          >
            <TableHead>
              <TableRow>
                {headCells?.map((column) => (
                  <TableCell
                    align="center"
                    sx={{
                      // color: '#FFF !important',
                      // backgroundColor: `${theme.palette.primary.main} !important`,
                      fontFamily: 'overpass',
                      fontSize: 14,
                      fontWeight: 'bold',
                      whiteSpace: 'nowrap',
                      padding: '10px',
                      textAlign: column.align,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {enableSearch && (
                <TableRow
                  className="noTableCellBorder"
                  sx={{
                    '.MuiTableCell-root': {
                      backgroundColor: 'transparent ',
                      padding: '8px 15px',
                      borderBottom: 'none',
                    },
                    '.css-wrnu0i-MuiInputBase-root': {
                      fontSize: '13px',
                    },
                    '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                      padding: '2px 4px',
                    },
                    '.css-1gqfvv-MuiPaper-root': {
                      // boxShadow: "none",
                      // borderBottom: "solid 1px rgba(0,0,0,0.24)",
                      borderRadius: '0px',
                    },
                    // display: !enableSearch ? "none" : "",
                  }}
                >
                  <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                    <TDSTCSCustomSearch
                      fieldType=""
                      searchValues={searchValues[keys.invoicenumber] ?? ''}
                      onChange={(e) => handleSearchChange(e?.target?.value, keys.invoicenumber)}
                      onClick={(e) => handleSearchChange('', keys.invoicenumber)}
                    />
                  </TableCell>
                  <TableCell sx={{ border: 'none !important' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* <CustomDate
                        ref={DateRangeRef}
                        value={[
                          filterColumns.InvoiceDateFrom ? dayjs.unix(filterColumns.InvoiceDateFrom) : null,
                          filterColumns.InvoiceDateTo ? dayjs.unix(filterColumns.InvoiceDateTo) : null,
                        ]}
                        onChange={(e) => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            InvoiceDateFrom: e.from || '',
                            InvoiceDateTo: e.to || '',
                          }));
                          setSearchType('invDate');
                        }}
                      />
                      {filterColumns.InvoiceDateFrom || filterColumns.InvoiceDateTo ? (
                        <IconButton
                          type="button"
                          sx={{ p: '0px', fontSize: '20px' }}
                          onClick={() => {
                            setFilterColumns((prev) => ({
                              ...prev,
                              InvoiceDateFrom: '',
                              InvoiceDateTo: '',
                            }));
                            setSearchType('invDate');
                            if (DateRangeRef.current?.clear) {
                              DateRangeRef.current.clear(); // Optional: if CustomDate has a `clear` method
                            }
                          }}
                        >
                          <Close />
                        </IconButton>
                      ) : (
                        <IconButton type="button" sx={{ p: '0px', fontSize: '20px' }}>
                          <Search />
                        </IconButton>
                      )} */}
                      <DateRangeRsuite
                        ref={DateRangeRef}
                        containerRef={tableRef}
                        value={[
                          filterColumns.InvoiceDateFrom ? (filterColumns.InvoiceDateFrom) : null,
                          filterColumns.InvoiceDateTo ? (filterColumns.InvoiceDateTo) : null,
                        ]}
                        onChange={(e) => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            InvoiceDateFrom: e.from || '',
                            InvoiceDateTo: e.to || '',
                          }));
                          setSearchType('invDate');
                        }}
                      />
                      
                    </Box>
                  </TableCell>
                  <TableCell sx={{ border: 'none !important', alignItems: 'left' }}>
                    <TDSTCSCustomSearch
                      fieldType=""
                      searchValues={searchValues[keys.partyname]}
                      onChange={(e) => handleSearchChange(e?.target?.value, keys.partyname)}
                      onClick={(e) => handleSearchChange('', keys.partyname)}
                    />
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',

                        width: '100%',
                      }}
                    >
                      <Stack direction={'row'} height={'32px'} gap="5px">
                        <MoneyRangerPayRec
                          min={filterColumns.invoiceamountfrom}
                          max={filterColumns.invoiceamountto}
                          // maxValue={filterColumnsMaxValues.InvoiceAmount}
                          onChange={(e) => {
                            handleFilterBySearch(e, 'invoiceamount', e);
                            setSearchType('invoiceamount');
                          }}
                        />

                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.invoiceamountfrom !== '' || filterColumns.invoiceamountto !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  invoiceamountfrom: '',
                                  invoiceamountto: '',
                                }));
                                setSearchType('invoiceamount');
                              }}
                            />
                          ) : (
                            <Search fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',

                        width: '100%',
                      }}
                    >
                      <Stack direction={'row'} height={'32px'} gap="5px">
                        <MoneyRangerPayRec
                          min={filterColumns.receivedamountfrom}
                          max={filterColumns.receivedamountto}
                          // maxValue={filterColumnsMaxValues.InvoiceAmount}
                          onChange={(e) => {
                            handleFilterBySearch(e, 'receivedamount', e);
                            setSearchType('receivedamount');
                          }}
                        />

                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.receivedamountfrom !== '' || filterColumns.receivedamountto !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  receivedamountfrom: '',
                                  receivedamountto: '',
                                }));
                                setSearchType('receivedamount');
                              }}
                            />
                          ) : (
                            <Search fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',

                        width: '100%',
                      }}
                    >
                      <Stack direction={'row'} height={'32px'} gap="5px">
                        <MoneyRangerPayRec
                          min={filterColumns.balancedueamountfrom}
                          max={filterColumns.balancedueamountto}
                          // maxValue={filterColumnsMaxValues.InvoiceAmount}
                          onChange={(e) => {
                            handleFilterBySearch(e, 'balancedueamount', e);
                            setSearchType('balancedueamount');
                          }}
                        />

                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.balancedueamountfrom !== '' || filterColumns.balancedueamountto !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  balancedueamountfrom: '',
                                  balancedueamountto: '',
                                }));
                                setSearchType('balancedueamount');
                              }}
                            />
                          ) : (
                            <Search fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                  <TableCell sx={{ width: '100%' }}>
                    <Paper
                      sx={{
                        p: '2px 4px',

                        width: '100%',
                      }}
                    >
                      <Stack direction={'row'} height={'32px'} gap="5px">
                        <MoneyRangerPayRec
                          min={filterColumns.creditperiodfrom}
                          max={filterColumns.creditperiodto}
                          // maxValue={filterColumnsMaxValues.InvoiceAmount}
                          onChange={(e) => {
                            handleFilterBySearch(e, 'creditperiod', e);
                            setSearchType('creditperiod');
                          }}
                          currencyType={'Days'}
                        />

                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.creditperiodfrom !== '' || filterColumns.creditperiodto !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  creditperiodfrom: '',
                                  creditperiodto: '',
                                }));
                                setSearchType('creditperiod');
                              }}
                            />
                          ) : (
                            <Search fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* <CustomDate
                        ref={DateRangeRef}
                        value={[
                          filterColumns.DueDateFrom ? dayjs.unix(filterColumns.DueDateFrom) : null,
                          filterColumns.DueDateTo ? dayjs.unix(filterColumns.DueDateTo) : null,
                        ]}
                        onChange={(e) => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            DueDateFrom: e.from || '',
                            DueDateTo: e.to || '',
                          }));
                          setSearchType('dueDate');
                        }}
                      />
                      {filterColumns.DueDateFrom || filterColumns.DueDateTo ? (
                        <IconButton
                          type="button"
                          sx={{ p: '0px', fontSize: '20px' }}
                          onClick={() => {
                            setFilterColumns((prev) => ({
                              ...prev,
                              DueDateFrom: '',
                              DueDateTo: '',
                            }));
                            setSearchType('dueDate');
                            if (DateRangeRef.current?.clear) {
                              DateRangeRef.current.clear(); // Optional: if CustomDate has a `clear` method
                            }
                          }}
                        >
                          <Close />
                        </IconButton>
                      ) : (
                        <IconButton type="button" sx={{ p: '0px', fontSize: '20px' }}>
                          <Search />
                        </IconButton>
                      )} */}
                      <DateRangeRsuite
                        ref={DateRangeRef}
                        containerRef={tableRef}
                        value={[
                          filterColumns.DueDateFrom ? dayjs.unix(filterColumns.DueDateFrom) : null,
                          filterColumns.DueDateTo ? dayjs.unix(filterColumns.DueDateTo) : null,
                        ]}
                        onChange={(e) => {
                          setFilterColumns((prev) => ({
                            ...prev,
                            DueDateFrom: e.from || '',
                            DueDateTo: e.to || '',
                          }));
                          setSearchType('dueDate');
                        }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: '2px 4px',

                        width: '100%',
                      }}
                    >
                      <Stack direction={'row'} height={'32px'} gap="5px">
                        <MoneyRangerPayRec
                          min={filterColumns.overduedaysfrom}
                          max={filterColumns.overduedaysto}
                          // maxValue={filterColumnsMaxValues.InvoiceAmount}
                          onChange={(e) => {
                            handleFilterBySearch(e, 'overduedays', e);
                            setSearchType('overduedays');
                          }}
                          currencyType={'Days'}
                        />

                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.overduedaysfrom !== '' || filterColumns.overduedaysto !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  overduedaysfrom: '',
                                  overduedaysto: '',
                                }));
                                setSearchType('overduedays');
                              }}
                            />
                          ) : (
                            <Search fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                </TableRow>
              )}
              {recData.length === 0 ? (
                <>
                  <TableRow>
                    <TableCell
                      colSpan={enableSearch && recData.length === 0 ? 6 : headCells?.length}
                      align="center"
                      sx={{
                        color: '#818694',
                        fontFamily: 'overpass',
                        fontSize: 15,
                        fontWeight: 'bold',
                      }}
                    >
                      NO DATA FOUND
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <>
                  {recData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    return (
                      <TableRow
                        className="noTableCellBorder"
                        sx={{
                          '.MuiTableCell-root': {
                            backgroundColor: 'transparent ',
                            padding: '8px 15px',
                            borderBottom: 'none',
                          },
                        }}
                      >
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          <a
                            className="myLink"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            href={
                              reportType === 'ReceivableOutStanding'
                                ? `/viewnewinvoicetax/${row?.invNo}?transaction=${row.id}`
                                : `/viewnewpurchasetax/${row?.invNo}?transaction=${row.id}`
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {row?.invNo}
                          </a>
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          {row?.invDate}
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          {row?.dName}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          ₹ {MoneyFormatv3(Number(row?.invAmt).toFixed(2), 'en-IN')}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          ₹ {MoneyFormatv3(Number(row?.recAmt).toFixed(2), 'en-IN')}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          ₹ {MoneyFormatv3(Number(row?.oAmnt).toFixed(2), 'en-IN')}
                        </TableCell>

                        <TableCell align="right" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          {row?.creditPrd}
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap', padding: '5px' }}>
                          {row?.dueDate}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            whiteSpace: 'nowrap',
                            padding: '5px',
                            color: row?.overDays < 0 ? 'red' : row?.overDays >= 0 ? 'green' : 'inherit',
                            fontWeight: 600,
                          }}
                        >
                          {`${Math.abs(Number(row?.overDays))} days`}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {recData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={defaultRowsPerPageOptions}
            component="div"
            count={recData?.[0]?.totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => {
              if (newPage > page) {
                if (recData?.length !== recData?.[0]?.totalCount)
                  if (recData.length < rowsPerPage * (newPage + 1)) {
                    getReceivablesData(
                      startTimeStamp,
                      endTimeStamp,
                      '',
                      recData?.length,
                      Math.abs(rowsPerPage * (newPage + 1) - recData.length),
                      true,
                      1
                    );
                  }
              }
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        )}

        {/* <NewAgeingModal open={ageingModal} setOpen={setAgeingModal} ageingData={ageingData} msg={reportType} /> */}
        <NewPayableReceivableAgeing open={ageingModal} setOpen={setAgeingModal} ageingData={ageingData} msg={reportType} />
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </Box>
  );
}

export default NewOutStandingReport;
